import React, { useEffect, useState, Fragment } from 'react'
import Layout from '../../components/Layout/Layout'
import { SearchIcon, QuestionMarkCircleIcon, DotsHorizontalIcon } from '@heroicons/react/solid';
import { DocumentDownloadIcon } from "@heroicons/react/outline";
import InvestmentServices from './../../services/InvestmentServices';
import { convert, formatDate } from './../../utils/convertDate';
import Paginate from '../../utils/Paginate';
import DatePicker from 'react-date-picker';
import { Menu, Transition } from '@headlessui/react'
import fire from './../../utils/Toastr';
import Spinner from './../../utils/Spinner';



const statusStyles = {
    Processed: 'bg-green-500 text-white',
    Failed: 'bg-orange-600 text-white',
    Pending: 'bg-amber-400 text-white',
    Rejected: 'bg-orange-600 text-white',
    Inactive: 'bg-orange-600 text-white',
    true: 'bg-green-500 text-white',
    false: 'bg-orange-600 text-white'
}


function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}

export default function Investments() {
    const [investments, setInvestments] = useState([])
    const [search, setSearch] = useState("")
    const [pageIndex, setPageIndex] = useState(1);
    const [prevPage, setPrev] = useState(false);
    const [pageNumber, setPageNumber] = useState(1);
    const [totalPage, setPage] = useState(0)
    const [nextPage, setNextPage] = useState(false);
    const [from, setFrom] = useState("");
    const [to, setTo] = useState("");
    const [investStatus, setInvestStatus] = useState("");
    const [pageLength, setPageLength] = useState("")
    const oldFrom = new Date().setDate(new Date().getDate() - 7);
    const [formValues, setFormValues] = useState({
        from: new Date(oldFrom),
        to: new Date()
    })
    const defaultTo = formatDate(new Date());
    const longNew = formatDate(defaultTo);
    const [too, setToo] = useState(convert(longNew));
    const defaultFrom = formatDate(new Date().setDate(new Date().getDate() - 7))
    const longDate = formatDate(defaultFrom);
    const [fromm, setFromm] = useState(convert(longDate));
    const [investLoader, setInvestLoader] = useState(false);
    const [rejectLoader, setrejectLoader] = useState(false);

    const list = async () => {
        const resp = await InvestmentServices.listInvestments(pageIndex, 10, search, fromm, too, investStatus);
        console.log("investmentstatus", investStatus)
        setInvestments([...resp.data.result]);
        setPageLength([...resp.data.result].length);
        setPageNumber(resp.data.totalCount);
        setPageIndex(resp.data.pageIndex);
        setPrev(resp.data.hasPreviousPage);
        setPage(resp.data.totalPages);
        setNextPage(resp.data.hasNextPage);
        
    }
    const handleSort = async (txt) => {
        if (txt === "All") {
            const resp = await InvestmentServices.listInvestments(pageIndex, 10, search, fromm, too, investStatus);
            setInvestments([...resp.data.result]);
            setPageLength([...resp.data.result].length);
            setPageNumber(resp.data.totalCount);
            setPageIndex(resp.data.pageIndex);
            setPrev(resp.data.hasPreviousPage);
            setPage(resp.data.totalPages);
            setNextPage(resp.data.hasNextPage);
          
        } else {
            setInvestStatus(txt);
            const resp = await InvestmentServices.listInvestments(pageIndex, 10, search, fromm, too, txt);
            setInvestments([...resp.data.result]);
            setPageLength([...resp.data.result].length);
            setPageNumber(resp.data.totalCount);
            setPageIndex(resp.data.pageIndex);
            setPrev(resp.data.hasPreviousPage);
            setPage(resp.data.totalPages);
            setNextPage(resp.data.hasNextPage);
          
        }

    }

    const dateValidation = {
        fromHandler: (event) => {
            setFormValues({ ...formValues, from: event })
        },
        toHandler: (event) => {
            setFormValues({ ...formValues, to: event })
        }
    };
    const range = async (e) => {
        e.preventDefault();
        const newDate = formatDate(formValues.from)
        setFrom(formValues.from)
        var longDate = formatDate(newDate);
        setFromm(convert(longDate));

        const toDate = formatDate(formValues.to);
        setTo(formValues.to)
        setToo(convert(toDate));

        const resp = await InvestmentServices.listInvestments(pageIndex, 10, search, convert(newDate), convert(toDate), investStatus);
        setInvestments([...resp.data.result]);
        setPageLength([...resp.data.result].length);
        setPageNumber(resp.data.totalCount);
        setPageIndex(resp.data.pageIndex);
        setPrev(resp.data.hasPreviousPage);
        setPage(resp.data.totalPages);
        setNextPage(resp.data.hasNextPage);
      
    }
    const exportCSV = async () => {
        const resp = await InvestmentServices.exportInvestments(search, fromm, too, investStatus);
        window.open(resp.data);
    }

    const searchInvest = async (text) => {
             setSearch(text);

    }
    const approve = async (id) => {
        setInvestLoader(true);
        const response = await InvestmentServices.approveInvestment({
            investmentId: id
        });
        if (response) {            
            fire("success", response.message);
            setTimeout(() => {
                window.location.reload();
            }, 5000);
        } 
        setInvestLoader(false);

    }
    const reject = async (id) => {
        setrejectLoader(true);
        const response = await InvestmentServices.rejectInestment({
            investmentId: id
        });
        if (response) {          
            fire("success", response.message);
            setTimeout(() => {
                window.location.reload();
            }, 5000);
        } 
        setrejectLoader(false);
    }
    useEffect(() => {
        list();
    }, [pageIndex])
    return (
        <div>
            <Layout title='Investments' pageTag={'investment'} current={'/investments'}>
                <React.Fragment>
                    <div className='max-w-7xl mx-auto px-4 sm:px-6 md:px-8'>
                        <div className="mt-4 sm:mt-0 sm:ml-16 flex justify-end">
                            <button
                                type="button"
                                onClick={exportCSV}
                                className="hover:text-white active:text-white inline-flex mr-2 items-center justify-center rounded-md border border-transparent btn-green px-2 py-2 text-sm font-medium text-green shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:w-auto"
                            >
                                <DocumentDownloadIcon className="w-4 mr-1.5" />
                                Export CSV
                            </button>
                        </div>
                        <div className="sm:flex sm:items-center mt-10">

                            <div className="sm:flex-auto flex">
                              
                                <div className=" relative rounded-md shadow-sm ml-3">
                                    <p className='text-sm leading-3 text-gray-500'>From</p>
                                    <div>
                                        <DatePicker onChange={dateValidation.fromHandler} value={formValues.from} />
                                    </div>
                                </div>
                                <div className=" relative rounded-md shadow-sm ml-3">
                                    <p className='text-sm leading-3 text-gray-500'>To</p>
                                    <div>
                                        <DatePicker onChange={dateValidation.toHandler} value={formValues.to} />
                                    </div>
                                </div>
                                <div className='flex ml-4'>
                                    <div className="mt-5 relative rounded-md shadow-sm">
                                        <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                            <SearchIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
                                        </div>
                                        <input
                                            type="text"
                                            name="user"
                                            id="user"
                                            onChange={(e) => searchInvest(e.target.value)}
                                            className="focus:ring-indigo-500 focus:border-indigo-500 block w-full pl-10 sm:text-sm border-gray-300 rounded-md"
                                            placeholder="Search investments"
                                        />
                                        <div className=" absolute inset-y-0 right-0 flex items-center pr-3">
                                            <div className='tooltip'>
                                                <QuestionMarkCircleIcon className="w-4 mr-1.5 text-gray-400" />
                                                <span className="tooltiptext"> <p>Search by source account number,investment category,investment type, surname and first name</p></span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='mt-5 ml-4'>
                                    <button
                                        onClick={range}
                                        className='hover:text-white active:text-white inline-flex mr-2 items-center justify-center rounded-md border border-transparent btn-green px-6 py-2 text-sm font-medium text-green shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:w-auto'>Search</button>
                                </div>
                                <div className="mt-5 relative rounded-md shadow-sm ml-3">
                                    <select
                                        id="currency"
                                        name="currency"
                                        onChange={(e) => handleSort(e.target.value)}
                                        placeholder="Sort by"
                                        className="focus:ring-indigo-500 focus:border-indigo-500 h-full py-0 pl-2 pr-7 border-gray-300 bg-transparent text-gray-500 sm:text-sm rounded-md"
                                    >
                                        <option value={"All"}>Sort by</option>
                                        <option value={"All"}>All</option>
                                        <option value={"Started"}>Started</option>
                                        <option value={"Pending"}>Pending</option>
                                        <option value={"Processed"}>Processed</option>
                                        <option value={"Rejected"}>Rejected </option>
                                        <option value={"Failed"}>Failed</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        {investments.length === 0 ? (
                            <div className=" mt-8"> No data available for these dates to show. </div>
                        ) : 
                          <>
                            <div className="mt-8 flex flex-col">
                                <div className="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
                                    <div className="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8">
                                        <div className="relative overflow-hidden ring-1 ring-black ring-opacity-5 md:rounded-lg">

                                            <table className="min-w-full table-fixed divide-y divide-gray-300 mb-24">
                                                <thead>
                                                    <tr>

                                                        <th scope="col" className="min-w-[9rem] py-3.5 pr-3 italic font-normal text-left text-sm  text-gray-900">
                                                            Investor First Name
                                                        </th>
                                                        <th scope="col" className="min-w-[10rem] px-3 py-3.5 text-left text-sm italic font-normal text-gray-900">
                                                            Investor Last Name
                                                        </th>
                                                        <th scope="col" className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-900">
                                                            Amount
                                                        </th>
                                                        <th scope="col" className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-900">
                                                            Currency
                                                        </th>
                                                        <th scope="col" className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-900">
                                                            Tenure(Days)
                                                        </th>
                                                        <th scope="col" className=" min-w-[10rem]  py-3.5 text-left text-sm italic font-normal text-gray-900">
                                                            Source Account Number
                                                        </th>
                                                        <th scope="col" className="min-w-[8rem]  py-3.5 text-left text-sm italic font-normal text-gray-900">
                                                            Investment Status
                                                        </th>

                                                        <th scope="col" className="min-w-[8rem] py-3.5 text-left text-sm italic font-normal text-gray-900">
                                                            Rate (%)
                                                        </th>
                                                        <th scope="col" className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-900">
                                                            Investment Type
                                                        </th>
                                                        <th scope="col" className="min-w-[10rem] px-3 py-3.5 text-left text-sm italic font-normal text-gray-900">
                                                            Investment Category
                                                        </th>

                                                        <th scope="col" className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-900">
                                                            Date Created
                                                        </th>

                                                        <th scope="col" className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-900">

                                                        </th>
                                                        <th scope="col" className="px-3 py-3.5 text-left text-sm italic font-normal text-gray-900">
                                                            <span className="sr-only">Edit</span>
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody className="divide-y divide-gray-200 bg-white">
                                                    {investments.map((person, i) => (
                                                        <tr key={i} className="bg-gray-50">
                                                            <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{person.investorFirstName}</td>
                                                            <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{person.investorLastName}</td>
                                                            <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{person.amount}</td>
                                                            <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">`{person.investmentCurrency}</td>
                                                            <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{person.tenure}</td>
                                                            <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{person.sourceAccountNumber}</td>
                                                            <td><span className={classNames(
                                                                statusStyles[person.investmentStatus], "inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium text-gray-900")}> {person.investmentStatus}</span>
                                                            </td>
                                                            <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{person.rate}</td>
                                                            <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{person.investmentTypeName}</td>
                                                            <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{person.investmentCategoryName}</td>
                                                            <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{formatDate(person.dateCreated)}</td>
                                                            {person.investmentStatus.toLowerCase() === "pending" &&
                                                                <td className="whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-6">

                                                                    <Menu as="div" className="ml-3  flex-shrink-0">
                                                                        <div>
                                                                            <Menu.Button className="  flex text-sm text-white">
                                                                                <span className="sr-only">Open user menu</span>
                                                                                <DotsHorizontalIcon className='w-8 text-gray-400' />
                                                                            </Menu.Button>
                                                                        </div>
                                                                        <Transition
                                                                            as={Fragment}
                                                                            enter="transition ease-out duration-100"
                                                                            enterFrom="transform opacity-0 scale-95"
                                                                            enterTo="transform opacity-100 scale-100"
                                                                            leave="transition ease-in duration-75"
                                                                            leaveFrom="transform opacity-100 scale-100"
                                                                            leaveTo="transform opacity-0 scale-95"
                                                                        >
                                                                            <Menu.Items className="origin-top-right absolute right-6 mt-2 w-40 rounded-md shadow-lg py-1 bg-white ring-1 ring-black ring-opacity-5 focus:outline-none">

                                                                                <button
                                                                                    type='button'
                                                                                    onClick={() => approve(person.id)}
                                                                                    className="block py-2 px-5 text-sm text-gray-700 text-left">
                                                                                    {investLoader ? <Spinner /> : "Approve"}
                                                                                </button>
                                                                                <button
                                                                                    type='button'
                                                                                    onClick={() => reject(person.id)}
                                                                                    className="block py-2 px-5 text-sm text-gray-700 text-left">
                                                                                    {rejectLoader ? <Spinner /> : "Reject"}
                                                                                </button>
                                                                            </Menu.Items>
                                                                        </Transition>
                                                                    </Menu>


                                                                </td>}
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <Paginate
                                    nextPage={nextPage}
                                    pageIndex={pageIndex}
                                    totalCount={pageNumber}
                                    totalPages={totalPage}
                                    prevPage={prevPage}
                                    setPageIndex={setPageIndex}
                                />
                        </>
                        }
                      

                    </div>
                </React.Fragment>
            </Layout>


        </div>
    )
}